module.exports = __webpack_public_path__ + "img/vende_tu_auto_paso2_mobile.354fcf77.png";